import { Paper, CircularProgress } from "@material-ui/core";
import { useEffect, useRef } from "react";
import profileImg from "../../images/blank-profile.png";
import { getAddedMemberActivity } from "../../../../Redux/Actions/ActivityHistoryAction";
import { useDispatch, useSelector } from "react-redux";
import CamelCaseString from "../../../../Common/CamelCaseString";

const MembersAddedContainer = () => {
  const activityHistoryData = useSelector((state) => state.activityHistoryData);
  const listInnerRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    getAddedMemberActivity(dispatch, {
      pageNumber: activityHistoryData?.pageNumber,
      status: true,
    });
  }, []);

  const onScroll = () => {
    if (
      activityHistoryData?.pageNumber <= activityHistoryData?.totalPages - 1 &&
      !activityHistoryData?.loading
    ) {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if (Math.round(scrollTop + 1 + clientHeight) >= scrollHeight) {
          getAddedMemberActivity(dispatch, {
            pageNumber: activityHistoryData?.pageNumber,
            status: false,
          });
        }
      }
    }
  };

  return (
    <div className="position-relative">
      <div
        className="height-350 overflow-y"
        onScroll={() => onScroll()}
        ref={listInnerRef}
      >
        {activityHistoryData?.activityData?.memberAdded?.map((item, index) => (
          <div
            key={index}
            className="main-card-box pd-10 brd-grey mg-bottom-20"
          >
            <div className="d-flex-align-cent">
              <img
                alt=""
                src={
                  item?.uploadedLogo && item?.uploadedLogo?.filePath
                    ? item.uploadedLogo.filePath
                    : profileImg
                }
                className="profile-img"
              />
              <div className="pd-15">
                <p className="font-17 lightblack bold">
                  <span className="skBlue">{item?.memberAdded?.firstName}</span>{" "}
                  is added as{" "}
                  <span className="skBlue">
                    {CamelCaseString(item?.userRoles[0]?.displayName)}
                  </span>{" "}
                  by {item?.memberAdded?.memberAddedBy}
                </p>
                <p>{item?.lastSeen}</p>
              </div>
            </div>
          </div>
        ))}
        {!activityHistoryData?.loading &&
          !activityHistoryData?.error &&
          activityHistoryData?.activityData?.memberAdded?.length == 0 && (
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">
                No feed available currently. Once you or your Coaches, Athletes
                add any member , it will become available here
              </p>
            </Paper>
          )}

        {!activityHistoryData?.loading && activityHistoryData?.error && (
          <p className="nodatabox">
            <Paper className="activity-trending-container2  pd-10 mg-top-10">
              <p className="nodatabox">{activityHistoryData?.error?.message}</p>
            </Paper>
          </p>
        )}
      </div>
      <div
        className="activity-history-loading-container"
        hidden={!activityHistoryData?.loading}
      >
        <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
          <CircularProgress
            className="rounded-circle"
            color="success"
            sx={{ fontSize: 10, color: "#002244" }}
            disableShrink
          />
        </div>
      </div>
    </div>
  );
};

export default MembersAddedContainer;
